import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const HandshakeIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        opacity="0.2"
        d="M25 19.1076L20.4004 23.7072C20.2783 23.8294 20.1266 23.9178 19.9602 23.9639C19.7938 24.01 19.6182 24.0122 19.4507 23.9703L12.2061 22.1591C12.0702 22.1252 11.943 22.063 11.8326 21.9767L5 16.6339L9.0718 8.97363L15.4868 7.10344C15.716 7.03664 15.9614 7.054 16.1789 7.1524L20.5 9.1076H17.9142C17.7829 9.1076 17.6529 9.13347 17.5315 9.18372C17.4102 9.23398 17.3 9.30764 17.2071 9.4005L12.3153 14.2923C12.214 14.3936 12.1356 14.5155 12.0855 14.6497C12.0354 14.784 12.0148 14.9274 12.0249 15.0703C12.0351 15.2132 12.0758 15.3523 12.1444 15.4781C12.213 15.6039 12.3078 15.7134 12.4224 15.7994L13.1 16.3076C13.7924 16.8269 14.6345 17.1076 15.5 17.1076C16.3655 17.1076 17.2076 16.8269 17.9 16.3076L19.5 15.1076L25 19.1076Z"
        fill="#2E2E2E"
      />
      <path
        d="M30.0897 15.2232L27 16.7681L23 9.10781L26.1212 7.54722C26.3557 7.42998 26.6268 7.40951 26.8763 7.49022C27.1257 7.57094 27.3335 7.74639 27.4548 7.97878L30.5289 13.8659C30.5904 13.9836 30.6278 14.1124 30.639 14.2447C30.6501 14.3771 30.6348 14.5103 30.5939 14.6367C30.553 14.763 30.4874 14.8799 30.4008 14.9807C30.3143 15.0814 30.2085 15.1638 30.0897 15.2232V15.2232Z"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.99991 16.634L1.91021 15.0892C1.79143 15.0298 1.68567 14.9473 1.5991 14.8466C1.51253 14.7459 1.44688 14.629 1.406 14.5026C1.36511 14.3763 1.3498 14.243 1.36096 14.1107C1.37212 13.9784 1.40953 13.8496 1.471 13.7319L4.54511 7.84475C4.66646 7.61236 4.87422 7.43691 5.12366 7.35619C5.3731 7.27548 5.64426 7.29594 5.87875 7.41319L8.99991 8.97377L4.99991 16.634Z"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27 16.768L25 19.1078L20.4004 23.7074C20.2783 23.8295 20.1266 23.9179 19.9602 23.964C19.7938 24.0101 19.6182 24.0123 19.4507 23.9704L12.2061 22.1593C12.0702 22.1253 11.943 22.0632 11.8326 21.9769L5 16.634"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.9991 19.1077L19.4991 15.1077L17.8991 16.3077C17.2067 16.827 16.3646 17.1077 15.4991 17.1077C14.6336 17.1077 13.7915 16.827 13.0991 16.3077L12.4215 15.7995C12.3069 15.7135 12.2121 15.6039 12.1435 15.4781C12.0749 15.3523 12.0342 15.2133 12.024 15.0704C12.0138 14.9274 12.0345 14.784 12.0846 14.6498C12.1347 14.5156 12.2131 14.3937 12.3144 14.2924L17.2062 9.40056C17.299 9.3077 17.4093 9.23404 17.5306 9.18379C17.6519 9.13353 17.782 9.10767 17.9133 9.10767H22.9991"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.07227 8.97363L15.4873 7.10344C15.7164 7.03664 15.9619 7.054 16.1794 7.1524L20.5005 9.10761"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 26.6077L10.2326 25.6658C10.0797 25.6276 9.938 25.5538 9.81907 25.4504L7 23"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HandshakeIcon;
